/** Палитра аватаров (graphite/accent-нейтральная, без привязки к фейк-ролям). */
const AVATAR_PALETTE = [
  '#1474FF',
  '#0ea472',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#0ea5e9',
  '#ec4899',
  '#14b8a6',
];

/** Детерминированный цвет аватара по строке-сидy (id/имя пользователя). */
export function avatarColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}
